<script>
import appConfig from '@/app.config'
import VideoList from './Video/VideoList.vue'
import SideBar from './SideBar'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapActions } from 'vuex'

export default {
  name: 'TrackvideoIndex',
  page: {
    title:
      window.location.pathname.split('/')[1] === 'trackvideo-2' ? 'Trackvideo' : 'Live Streaming',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    SideBar,
    VideoList,
  },
  mixins: [Helper, MixPanel],
  data() {
    return {
      id: this.$route.params.id || null,
      expiresDays: null,
      expiresOn: null,
    }
  },
  watch: {
    $route(to) {
      if (to.name === 'Live Streaming Trackvision') {
        document.title =
          this.$t('menuitems.liveStreaming.text') +
          ' | ' +
          this.$store.state.asset.data.tabTitle.general
      } else if (to.name === 'Track Video V2') {
        document.title = 'Trackvideo' + ' | ' + this.$store.state.asset.data.tabTitle.general
      }
    },
  },
  created() {
    this.track('Open Pelacakan Video New')
    if (window.location.pathname.split('/')[1] === 'live-streaming') {
      this.track('Open Trackvision Live Streaming')
    }
  },
  async mounted() {
    this.$store.dispatch('layout/toggleMenu', true)
    this.$store.commit('video/resetPlaylist')
  },

  methods: {
    ...mapActions('video', ['setVideoStreamStatusOff']),
  },
}
</script>

<template>
  <Layout>
    <div
      :class="{
        'card mc-liveview clearfix': $store.state.sidebar.sideBarOpen === true,
        'card mc-liveview clearfix close-sidebar': $store.state.sidebar.sideBarOpen === false,
      }"
    >
      <VideoList />
      <SideBar />
    </div>
  </Layout>
</template>
